import { ReactNode } from "react";

type ControlProps = Record<string, unknown>;

export type FormInputWrapperProps = {
  wrapperClassName?: string;
  children: (controlProps: ControlProps) => ReactNode;
} & ControlProps;

export function FormInputWrapper({ wrapperClassName, children, ...controlProps }: FormInputWrapperProps) {
  return <div className={wrapperClassName}>{children(controlProps)}</div>;
}
